import { DbotEventDispatcher, DecisionContext, DecisionTypeHandler } from "../common/commonDomain";
import {
  IncreaseShareCapitalPowerOfAttorney,
  IncreaseShareCapitalPowerOfAttorneyForm,
} from "./increaseShareCapitalPowerOfAttorneyDomain";
import { DecisionType } from "../../common/decisions";

export function initNewForm(
  dispatch: DbotEventDispatcher,
  context: DecisionContext,
  data?: IncreaseShareCapitalPowerOfAttorney,
): IncreaseShareCapitalPowerOfAttorneyForm {
  return new IncreaseShareCapitalPowerOfAttorneyForm(context, data);
}

export function applyForm(
  form: IncreaseShareCapitalPowerOfAttorneyForm,
): IncreaseShareCapitalPowerOfAttorney {
  return {
    type: DecisionType.increaseShareCapitalPowerOfAttorney,
    shareCapitalValue: form.shareCapitalValue.parsedValue ?? 0,
    shareCapitalDuration: form.shareCapitalDuration.value,
    shareCapitalDurationMonths: form.shareCapitalDurationMonths.parsedValue,
    isNewShareType: form.isNewShareType.value ?? false,
    isAllShareTypes: form.isAllShareTypes.value ?? false,
    shareTypes: form.shareTypes.selected,
    newShareTypeDescription: form.newShareTypeDescription.validatedValue,
    deviateFromShareholderRights: form.deviateFromShareholderRights.value ?? false,
    includeOtherProperties: form.includeOtherProperties.value ?? false,
    includeMerger: form.includeMerger.value ?? false,
    includeConvertingDebt: form.includeConvertingDebt.value ?? false,
    shareCapitalReasons: form.shareCapitalReasons.localizedTexts,
  };
}

export function validate(form: IncreaseShareCapitalPowerOfAttorneyForm) {
  return form.validate();
}

export function isValid(form: IncreaseShareCapitalPowerOfAttorneyForm) {
  return form.isValid;
}

export const increaseShareCapitalPowerOfAttorneyHandler: DecisionTypeHandler<
  DecisionType.increaseShareCapitalPowerOfAttorney,
  IncreaseShareCapitalPowerOfAttorney,
  IncreaseShareCapitalPowerOfAttorneyForm
> = {
  type: DecisionType.increaseShareCapitalPowerOfAttorney,
  initNewForm,
  isValid,
  validate,
  applyForm,
};
